import React, { Dispatch, SetStateAction } from 'react';
import {
  btnsBox,
  dialogContent,
  dialogContentBoxes,
  dialogTitle,
  closeBtn,
  inputOutlined,
  paperProps,
} from './ExtractModal.sx';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Button, FormControl, InputAdornment, OutlinedInput, RadioGroup, Typography } from '@mui/material';
import CloseIcon from 'app/components/Icons/CloseIcon';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import CustomSwitch from 'app/components/CustomSwitch';
import CustomInput from 'app/components/CustomInput';
import CustomSelect from 'app/components/CustomSelect';
import CalendarIcon from 'app/components/Icons/CalendarIcon';
import DatePicker from 'react-datepicker';
import useExtractModal from 'app/components/ExtractModal/useExtractModal';
import CustomRadio from 'app/components/CustomRadio';
import DownloadIcon from 'app/components/Icons/DownloadIcon';
import logger from 'app/utils/logger';
import FieldError from 'app/components/FieldError';
import { Controller, FormProvider } from 'react-hook-form';
import 'react-datepicker/dist/react-datepicker.css';
import LoaderFullScreen from 'app/components/LoaderFullScreen';
import EmailModal from "app/components/EmailModal";
import SuccessModal from "app/components/SuccessModal";
import Select from "react-select";
import SelectValueContainer from "app/components/SelectValueContainer";
import {OptionsWithIcon, SelectOption} from "app/components/SelectOption";
import {customStyles, labelStyle} from "app/pages/HomePage/AccountsBox/AccountsBox.sx";
import {selectStyles} from "app/components/Filter/Filter.sx";

interface Props {
  accountValue: string;
  accountsList?: any[];
}

const ExtractModal = (props: Props) => {
  const { accountValue,accountsList } = props;
  const {
    t,
    showEmail,
    setShowEmail,
    firstFocused,
    onFocusNext,
    onFocusEnd,
    handlerBlur,
    resNextDate,
    nextDate,
    handlerNextDate,
    secondFocused,
    onChangeFile,
    selectedFile,
    handlerEndDate,
    endDate,
    resEndDate,
    selectedPeriod,
    onChangePeriod,
    onChangeAccount,
    setShowExtractModal,
    showExtractModal,
    handlerOpenExtract,
    handleChangeEmail,
    handleChangeAutoStatementPeriod,
    emailInput,
    setEmailInput,
    isLoadingExtract,
    dataExtract,
    handleSave,
    selectedAutoStatementPeriod,
    handleDownload,
    errors,
    isValid,
    register,
    handleSubmit,
    control,
    methods,
    setValue,
    handleSwitch,
    handleClose,
    changeSwitch,
    isLoadingExtractActions,
    openEmailModal,
    setOpenEmailModal,
    handleSendToEmail,
    errorMessage,
    successModal,
    setSuccessModal,
    setErrorMessage,
    account,
    accOptions,
  } = useExtractModal({ accountValue,accountsList });

  return (
    <>
      <Button color={'tertiary'} sx={{ display: 'flex', gap: '12px' }} onClick={handlerOpenExtract}>
        <DownloadIcon />
        {t('homePage.extract')}
      </Button>
      {!isLoadingExtract && (
        <Dialog
          open={showExtractModal}
          PaperProps={{
            sx: paperProps,
          }}
          onClose={async () => {
            await handleClose();
            setShowExtractModal(false);
          }}
        >
          <DialogTitle sx={dialogTitle}>
            <Typography sx={{ fontSize: '26px', fontWeight: 600 }}>{t('homePage.extract')}</Typography>
            <Button
              color={'tertiary'}
              onClick={() => {
                setShowExtractModal(false);
                handleClose();
              }}
              sx={closeBtn}
            >
              <CloseIcon />
            </Button>
          </DialogTitle>
          <DialogContent sx={dialogContent}>
            <form onSubmit={handleSubmit(handleDownload)}>
              <Box sx={dialogContentBoxes}>
                {/*<CustomInput title={t('homePage.account')} value={accountValue} disabled={true} width={'100%'} />*/}
                <FormControl>
                  <Typography>{t('homePage.account')}</Typography>
                  <Select
                      styles={selectStyles}
                      isSearchable={false}
                      options={accOptions}
                      placeholder={t('homePage.account')}
                      components={{
                        IndicatorSeparator: () => null,
                        Option: OptionsWithIcon,
                      }}
                      value={account}
                      onChange={onChangeAccount}
                  />
                </FormControl>
                <FormControl>
                  <CustomSelect
                    options={dataExtract?.periodicy_types}
                    optionLabel={true}
                    optionValue={true}
                    title={t('homePage.period')}
                    placeholder={t('homePage.period')}
                    onChange={onChangePeriod}
                    value={selectedPeriod}
                    width={'100%'}
                    rest={{ ...register('selectPeriod') }}
                    isValid={errors?.selectPeriod !== undefined}
                    control={control}
                    valueOption={'value'}
                    labelOption={'title'}
                  />
                  <FieldError error={errors.selectPeriod} />
                </FormControl>
                {selectedPeriod?.value === '-1' && (
                  <>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                      <Typography sx={{ fontSize: '15px', fontWeight: 400 }}>{t('homePage.paymentDate')}</Typography>
                      <Box sx={{ display: 'flex', gap: '16px' }}>
                        <FormControl>
                          <OutlinedInput
                            inputProps={{ style: { paddingLeft: '12px' } }}
                            value={resNextDate}
                            onFocus={onFocusNext}
                            placeholder={t('homePage.fromDate')}
                            sx={inputOutlined}
                            startAdornment={
                              <InputAdornment sx={{ margin: '0px' }} position={'start'}>
                                <CalendarIcon sx={{ fill: 'transparent' }} />
                              </InputAdornment>
                            }
                            {...register('startDate', { value: resNextDate })}
                            error={errors.startDate !== undefined}
                          />
                          <FieldError error={errors.startDate} />
                        </FormControl>
                        <FormControl>
                          <OutlinedInput
                            inputProps={{ style: { paddingLeft: '12px' } }}
                            value={resEndDate}
                            onFocus={onFocusEnd}
                            placeholder={t('homePage.toDate')}
                            sx={inputOutlined}
                            startAdornment={
                              <InputAdornment sx={{ margin: '0px' }} position={'start'}>
                                <CalendarIcon sx={{ fill: 'transparent' }} />
                              </InputAdornment>
                            }
                            {...register('endDate', { value: resEndDate })}
                            error={errors.endDate !== undefined}
                          />
                          <FieldError error={errors.endDate} />
                        </FormControl>
                      </Box>
                    </Box>
                    {firstFocused && (
                      <Box sx={{ position: 'fixed', zIndex: 1, mt: '245px' }}>
                        <DatePicker
                          selected={nextDate}
                          onSelect={(date) => {
                            handlerNextDate(date);
                          }}
                          onChange={(date) => {
                            handlerNextDate(date);
                          }}
                          inline
                          shouldCloseOnSelect={true}
                          onClickOutside={handlerBlur}
                        />
                      </Box>
                    )}
                    {secondFocused && (
                      <Box sx={{ position: 'fixed', zIndex: 1, mt: '245px', ml: '100px' }}>
                        <DatePicker
                          selected={endDate}
                          onChange={(date) => {
                            handlerEndDate(date);
                          }}
                          onSelect={(date) => {
                            handlerEndDate(date);
                          }}
                          inline
                          shouldCloseOnSelect={true}
                          onClickOutside={handlerBlur}
                          minDate={nextDate}
                        />
                      </Box>
                    )}
                  </>
                )}
                <FormControl>
                  <CustomSelect
                    options={dataExtract?.file_format_types}
                    title={t('homePage.fileType')}
                    placeholder={t('homePage.fileType')}
                    width={'100%'}
                    onChange={onChangeFile}
                    value={selectedFile}
                    optionLabel={true}
                    optionValue={true}
                    rest={{ ...register('fileType') }}
                    isValid={errors?.fileType !== undefined}
                    control={control}
                    valueOption={'value'}
                    labelOption={'title'}
                  />
                  <FieldError error={errors.fileType} />
                </FormControl>
              </Box>
              <CustomSwitch
                sx={{ height: '48px' }}
                title={t('homePage.automation')}
                checked={showEmail}
                handleToggle={handleSwitch}
                rest={{ ...register('showEmail') }}
              />
              {showEmail && (
                <>
                  <FormControl sx={{ width: '100%' }}>
                    <CustomInput
                      title={'E-mail'}
                      placeholder={'E-mail'}
                      width={'100%'}
                      value={emailInput}
                      handleChange={(e: any) => handleChangeEmail(e)}
                      isValid={errors?.email !== undefined}
                      rest={{ ...register('email') }}
                    />
                    <FieldError error={errors.email} />
                  </FormControl>
                  <FormControl sx={{ mt: '16px' }}>
                    <Controller
                      render={({ field }) => (
                        <RadioGroup
                          sx={{ display: 'flex', flexDirection: 'row', gap: '8px' }}
                          {...field}
                          value={selectedAutoStatementPeriod}
                        >
                          {dataExtract.autostatement_types.map((item: any) => (
                            <CustomRadio
                              title={item.title}
                              value={item?.value}
                              checked={selectedAutoStatementPeriod === item.value}
                              key={item.value}
                              handleChange={(e: any) => handleChangeAutoStatementPeriod(e)}
                              mr={'8px'}
                              rest={{ ...register('periodicity') }}
                              isValid={errors?.periodicity !== undefined}
                              control={control}
                            />
                          ))}
                        </RadioGroup>
                      )}
                      name={'periodicity'}
                      control={control}
                    />
                    <FieldError error={errors.periodicity} />
                  </FormControl>
                </>
              )}
              <Box sx={btnsBox}>
                <Button type="submit">{t('homePage.download')}</Button>
                {(showEmail || changeSwitch) && (
                  <Button
                    type="submit"
                    color={'tertiary'}
                    sx={{ display: 'flex', gap: '12px', '& .MuiSvgIcon-root': { width: '22px', height: '22px' } }}
                    onClick={handleSubmit(handleSave)}
                  >
                    {t('homePage.save')}
                  </Button>
                )}
              </Box>
            </form>
          </DialogContent>
        </Dialog>
      )}
      {isLoadingExtractActions && <LoaderFullScreen open={isLoadingExtractActions} />}
      <EmailModal errorMessage={errorMessage} handleSubmit={handleSendToEmail} emailInput={emailInput} setEmailInput={setEmailInput} open={openEmailModal} close={setOpenEmailModal} headerText={'Çıxarışın əldə edilməsi'}/>
      <SuccessModal path={'home-page'} open={successModal} close={setSuccessModal} successText={'Məlumatlar bir neçə dəqiqə ərzində qeyd etdiyiniz e-poçt ünvanına göndəriləcək!'} />
    </>
  );
  // }
};

export default ExtractModal;
